import type { UseFormReturn } from "react-hook-form";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  RadioGroup,
  RadioGroupItem,
  Typography,
} from "@/components/ui";
import type { RepairIntakeFormData } from "@/store/useRepairIntakeStore";

type RepairIntakeRadioFieldProps = {
  form: UseFormReturn<RepairIntakeFormData>;
  name:
    | "section2.utReadingsAttached"
    | "section4.sdsAttached"
    | "section6.activeLeak"
    | "section7.installedUnderPressure"
    | "section7.goodPipeOnLandingZones"
    | "section7.defectsFieldVerified";
  label: string;
  helperText?: string;
};

export function RepairIntakeRadioField({ form, name, label, helperText }: RepairIntakeRadioFieldProps) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className="space-y-3">
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <RadioGroup
              value={field.value}
              onValueChange={field.onChange}
              className="flex flex-col gap-3 sm:flex-row sm:gap-6"
            >
              {["Yes", "No"].map((option) => {
                const optionId = `${name}-${option.toLowerCase()}`;

                return (
                  <div key={option} className="flex items-center gap-3">
                    <RadioGroupItem id={optionId} value={option} />
                    <label htmlFor={optionId} className="cursor-pointer">
                      <Typography variant="text-small" weight="medium">
                        {option}
                      </Typography>
                    </label>
                  </div>
                );
              })}
            </RadioGroup>
          </FormControl>
          {helperText ? <FormDescription>{helperText}</FormDescription> : null}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
